import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
	faTwitter,
	faGithub,
	faLinkedin,
	faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import Service from "../../service/Service";
import { useState, useEffect } from "react";

import "./styles/socials.css";

const Socials = () => {
	
	const [data, setData] = useState([]);
	const [socialdata, setSocialdata] = useState([]);
	useEffect(() => {
	  getData();
	  getSocialdata();
	}, []);
  
	const getData = async () => {
	  try {
		const documentData = await Service.getInfoById("about");
		if (documentData) {
		  setData(documentData);
		}
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
  
	const getSocialdata = async () => {
	  try {
		const documentData = await Service.getInfoById("socials");
		if (documentData) {
		  setSocialdata(documentData);
		}
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div className="socials">
			<div className="social">
				<a href={socialdata.twitter} target="_blank" rel="noreferrer">
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faTwitter}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on Twitter</div>
				</a>
			</div>

			<div className="social">
				<a href={socialdata.github} target="_blank" rel="noreferrer">
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faGithub}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on GitHub</div>
				</a>
			</div>

			<div className="social">
				<a
					href={socialdata.linkedin}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faLinkedin}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on LinkedIn</div>
				</a>
			</div>

			<div className="social">
				<a
					href={socialdata.instagram}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faInstagram}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on Instagram</div>
				</a>
			</div>

			<div className="email">
				<div className="email-wrapper">
					<a
						href={`mailto:${socialdata.email}`}
						target="_blank"
						rel="noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon icon={faEnvelope} />
						</div>

						<div className="social-text">{socialdata.email}</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Socials;
